import { StyleSheet, Font } from '@react-pdf/renderer';
// import OpenSansFont from './fonts/Open_Sans/OpenSans-Regular.ttf';
// import OpenSansBoldFont from './fonts/Open_Sans/OpenSans-SemiBold.ttf';

// Font.register({
//   family: 'Open Sans',
//   src: OpenSansFont,
// });
// Font.register({
//   family: 'Open Sans Bold',
//   src: OpenSansBoldFont,
// });

// Font.register({
//   family: 'Lato Italic',
//   src: `${__dirname}/fonts/Lato/Lato-Italic.ttf`,
// });
Font.register({
  family: 'Open Sans',
  src:
    'https://firebasestorage.googleapis.com/v0/b/museum-838f3.appspot.com/o/OpenSans-Regular.ttf?alt=media&token=5039bb7c-7840-4028-9d21-27acc8ff8cbd',
});

// Create styles
const styles = StyleSheet.create({
  page: {
    // backgroundColor: '#E4E4E4',
    backgroundColor: '#FFFFFF',
    fontFamily: 'Open Sans',
    paddingBottom: 36,
  },
  header: {
    margin: 20,
    marginBottom: 4,
    padding: 20,
    paddingBottom: 6,
    // border: 1,
    // borderColor: '#a4a0a4',
    // boxSizing: 'borderBox',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  headerText: {
    textTransform: 'uppercase',
  },
  headerImage: {},
  body: {
    margin: 20,
    marginTop: 4,
    padding: 0,
  },
  sectionTitle: {
    margin: 5,
    marginLeft: 10,
    padding: 10,
    // borderBottom: 1,
    fontSize: 14,
    // borderBottomColor: '#a4a0a4',
    boxSizing: 'borderBox',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    // fontFamily: 'Open Sans Bold',
  },
  section: {
    marginLeft: 14,
    marginRight: 14,
    display: 'flex',
    flexDirection: 'row',
    border: 1,
    boxSizing: 'borderBox',
    borderColor: '#a4a0a4',
  },
  descriptionSection1: {
    marginLeft: 14,
    marginRight: 14,
    display: 'flex',
    flexDirection: 'row',
    border: 1,
    borderBottom: 0,
    boxSizing: 'borderBox',
    borderColor: '#a4a0a4',
  },

  descriptionSection2: {
    marginLeft: 14,
    marginRight: 14,
    display: 'flex',
    flexDirection: 'row',
    border: 1,
    borderTop: 0,
    boxSizing: 'borderBox',
    borderColor: '#a4a0a4',
  },

  fullColumn: {
    display: 'flex',
    flexDirection: 'column',
    margin: 10,
    padding: 2,
    flexGrow: 1,
    border: 1,
    boxSizing: 'borderBox',
    borderColor: '#a4a0a4',
  },
  col: {
    margin: 5,
    padding: 2,
    flexGrow: 1,
    width: '45%',
  },
  colBorderless: {
    margin: 10,
    padding: 2,
    flexGrow: 1,
    border: 0,
    width: '45%',
  },
  line: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    padding: 6,
  },
  imageList: {
    alignItems: 'center',
    margin: 6,
    padding: 2,
    flexGrow: 1,
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    flexShrink: 1,
  },
  image: {
    margin: 5,
    padding: 6,
    border: 1,
    borderColor: '#a4a0a4',
    flexGrow: 1,
    maxWidth: '120',
    maxHeight: '128',
    // marginHorizontal: 155,
  },
  label: {
    width: '50%',
    fontSize: 10,
    // fontFamily: 'Open Sans Bold',
  },
  lineText: {
    fontSize: 10,
    width: '50%',
    // color: '#404040',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 10,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
});

export default styles;
